const PATHS = {
    success: (
        <polyline points="4,12 10,18 20,6" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    ),
    warn: (
        <>
            <path d="M12 3 L22 21 L2 21 Z" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinejoin="round" />
            <line x1="12" y1="10" x2="12" y2="15" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
            <circle cx="12" cy="18" r="1.2" fill="currentColor" />
        </>
    ),
    error: (
        <>
            <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="2.2" />
            <line x1="8" y1="8" x2="16" y2="16" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
            <line x1="16" y1="8" x2="8" y2="16" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
        </>
    ),
};

const TONE_COLORS = {
    success: "#7BC598",
    warn:    "#E8C257",
    error:   "#E07A6B",
};

export default function StatusIcon({ tone, size = 18 }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            aria-hidden
            style={{ color: TONE_COLORS[tone], display: "block", flexShrink: 0 }}
        >
            {PATHS[tone]}
        </svg>
    );
}
